// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Share: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M11 8c-.902 0-1.701.378-2.251 1.036L5.93 7.628C5.975 7.425 6 7.216 6 7c0-.216-.025-.425-.069-.628l2.817-1.409A2.981 2.981 0 0 0 11 6a3 3 0 1 0-2.932-2.372L5.25 5.038A2.88 2.88 0 0 0 3 4C1.343 4 0 5.316 0 7s1.343 3 3 3c.902 0 1.701-.378 2.251-1.036l2.817 1.409A3 3 0 1 0 11 8Zm0-6.5A1.501 1.501 0 1 1 9.5 3 1.5 1.5 0 0 1 11 1.5Zm-8 7a1.501 1.501 0 0 1 0-3 1.501 1.501 0 0 1 0 3Zm8 4c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.672 1.5-1.5 1.5Z"
            />
        </svg>
    );
};

export default React.memo(Share);
